import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Grid, Segment } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import {
  InventoryChart,
  InventoryReportsChart,
  OngoingActivitiesChart,
  ProductionPlanningChart,
} from './ChartConditions';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

interface linechart {
  label: string;
  data: number[];
  fill: boolean;
  backgroundColor: string;
  borderColor: string;
  lineTension: number;
}

interface Props {
  DataLabel: string[];
  MainData: number[];
  completedData: number[];
  LineChartData: linechart[];
  // InProgress: number[];
  // TapeMonthData:number[]
}

function DashboardChart({
  DataLabel,
  MainData,
  LineChartData,
  completedData,
}: // InProgress,
Props) {
  const {
    dashboardStore,
    activityStore,
    commonStore,
    userStore: { user },
  } = useStore();
  const { ChartInfosetRoleId, chartRoleInfo } = commonStore;

  useEffect(() => {
    chartRoleInfo.length = 0;
    if (
      dashboardStore.dashboard.L1CardValue === 'Inventory' ||
      dashboardStore.dashboard.L1CardValue === ''
    ) {
      if (dashboardStore.dashboard.L2CardValueInventory === 'Reports') {
        ChartInfosetRoleId(InventoryReportsChart);
      } else {
        ChartInfosetRoleId(InventoryChart);
      }
    } else if (dashboardStore.dashboard.L1CardValue === 'Production') {
      ChartInfosetRoleId(ProductionPlanningChart);
    } else if (dashboardStore.dashboard.L1CardValue === 'Orders') {
      ChartInfosetRoleId(OngoingActivitiesChart);
    } else {
      ChartInfosetRoleId([]);
    }
    // eslint-disable-next-line
  }, [
    dashboardStore.dashboard.L2CardValueInventory,
    dashboardStore.dashboard.L1CardValue,
  ]);

  const [doughnutDetails, setDoughnutDetails] = useState<{
    types: string[];
    counts: number[];
  }>({
    types: [],
    counts: [],
  });

  useEffect(() => {
    let types = [];
    let counts = [];

    switch (dashboardStore.dashboard.L1CardValue) {
      case 'Inventory':
        types = dashboardStore.dashboard.inventoryDoughnutChartDetails?.map(
          (data) => data.type,
        );
        counts = dashboardStore.dashboard.inventoryDoughnutChartDetails?.map(
          (data) => data.count,
        );
        setDoughnutDetails({
          types,
          counts,
        });
        break;
      case 'Production':
        types = activityStore.typeProduction?.map((data) => data.task);
        counts = activityStore.typeProduction?.map((data) => data.count);
        setDoughnutDetails({
          types,
          counts,
        });
        break;
      case 'Orders':
        types = dashboardStore.dashboard.inventoryDoughnutChartDetails?.map(
          (data) => data.type,
        );
        counts = dashboardStore.dashboard.inventoryDoughnutChartDetails?.map(
          (data) => data.count,
        );
        setDoughnutDetails({
          types,
          counts,
        });
        break;
      default:
        types = dashboardStore.dashboard.inventoryDoughnutChartDetails?.map(
          (data) => data.type,
        );
        counts = dashboardStore.dashboard.inventoryDoughnutChartDetails?.map(
          (data) => data.count,
        );
        setDoughnutDetails({
          types,
          counts,
        });
    }
    // eslint-disable-next-line
  }, [
    dashboardStore.dashboard.inventoryDoughnutChartDetails,
    activityStore.typeProduction,
  ]);
  // const sample = DataLabel.map(x=>
  //   workflowMonthData.map(y=>{
  //     let datas={  label: x,
  //            data: y,
  //            fill: true,
  //            backgroundColor: "rgba(75,192,192,0.2)",
  //            borderColor: "#64C9CF",
  //            lineTension: 1,

  //        }
  //   return datas})
  // )

  const commonFilterInprogress = () => {
    let filter = dashboardStore.dashboard.ProdchartInprogressLabel?.flatMap(
      (data: any) => {
        if (data !== '') {
          if (data !== 'NA') {
            return data;
          }
          return [];
        }
        return [];
      },
    );
    return filter;
  };

  let barChartDataSet: any[] = [];

  commonFilterInprogress()?.forEach((c: string, index: number) => {
    if (completedData[index] !== undefined) {
      barChartDataSet.push({
        name: c,
        val: '(' + completedData[index] + ')',
      });
    }
  });

  const Barchartdata = {
    labels: commonFilterInprogress(),
    options: {
      animation: true,
      maintainAspectRatio: false,
    },

    datasets: [
      {
        label: 'Production Planning (' + barChartDataSet.length + ')',
        // data: dashboardStore.dashboard?.prodChartData[4].Chart3Complete,
        data: completedData,
        backgroundColor: '#64C9CF',
      },
    ],
  };

  const chartdata = {
    labels: doughnutDetails.types,
    config: {
      type: 'doughnut',
    },
    datasets: [
      {
        backgroundColor: [
          '#83ce83',
          '#FF9A76',
          '#64C9CF',
          'rgb(255, 99, 132)',
          'rgb(255, 205, 86)',
          '#95D1CC',
          '#D47AE8',
        ],
        data: doughnutDetails.counts,
      },
    ],
  };
  const LineData = {
    labels: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    // bezierCurve : true,

    datasets: LineChartData?.flatMap((data: { label: string }) => {
      if (data.label !== 'NA') {
        if (data.label !== '') {
          return data;
        }
        return [];
      }
      return [];
    }),
  };

  const FirstBaroptions = {
    indexAxis: 'y',
    // Elements options apply to all of the options unless overridden in a dataset
    // In this case, we are setting the border of each horizontal bar to be 2px wide
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scaleOverride: true,
    scales: {
      y: {
        suggestedMin: 0,
        suggestedMax: 50,
      },
      x: {
        suggestedMin: 0,
        suggestedMax: 50,
      },
    },
    scaleBeginAtZero: true,
    plugins: {
      legend: {
        position: 'bottom',
        display: false,
        onClick: null,
      },
      title: {
        display: false,
        // text: `${dashboardStore.dashboard.L1CardValue }`,
      },
    },
  };
  return (
    <Segment
      // className="table-dash"
      style={{ overflowY: 'auto', width: 'calc(100vw - 3em)' }}
    >
      <Grid
        stackable
        columns={
          dashboardStore.dashboard.L1CardValue === 'Orders' ||
          (dashboardStore.dashboard.L1CardValue === 'Inventory' &&
            dashboardStore.dashboard.prodCount === 0) ||
          (dashboardStore.dashboard.L1CardValue === '' &&
            dashboardStore.dashboard.prodCount === 0)
            ? 3
            : 4
        }
      >
        <Grid.Row style={{ justifyContent: 'center' }}>
          {!commonStore.filterModeTwo?.includes(chartRoleInfo?.[0]?.id) && (
            <>
              {!(
                !(
                  dashboardStore.dashboard.L1CardValue === 'Inventory' &&
                  dashboardStore.dashboard.L2CardValueInventory === 'Reports'
                ) &&
                user?.customerName === 'CG' &&
                dashboardStore.dashboard.L2CardValueInventory !== 'Delivery' &&
                dashboardStore.dashboard.L1CardValue !== 'Production'
              ) && (
                <Grid.Column
                  className={
                    commonStore.filterModeZero?.includes(chartRoleInfo?.[0]?.id)
                      ? 'component-isDisabled'
                      : ''
                  }
                >
                  {/* first bar */}
                  {
                    <Bar
                      style={{ minHeight: '19rem' }}
                      data={chartdata}
                      options={FirstBaroptions as any}
                    />
                  }
                </Grid.Column>
              )}
            </>
          )}
          {!commonStore.filterModeTwo?.includes(chartRoleInfo?.[1]?.id) && (
            <>
              {!(
                !(
                  dashboardStore.dashboard.L1CardValue === 'Inventory' &&
                  dashboardStore.dashboard.L2CardValueInventory === 'Reports'
                ) &&
                user?.customerName === 'CG' &&
                dashboardStore.dashboard.L2CardValueInventory !== 'Delivery' &&
                dashboardStore.dashboard.L1CardValue !== 'Production'
              ) && (
                <Grid.Column>
                  <Bar
                    data={LineData as any}
                    className={
                      commonStore.filterModeZero?.includes(
                        chartRoleInfo?.[1]?.id,
                      )
                        ? 'component-isDisabled'
                        : ''
                    }
                  />
                </Grid.Column>
              )}
            </>
          )}
          {!commonStore.filterModeTwo?.includes(chartRoleInfo?.[2]?.id) &&
            (dashboardStore.dashboard.L1CardValue === 'Orders' ||
            (dashboardStore.dashboard.L1CardValue === 'Inventory' &&
              dashboardStore.dashboard.prodCount === 0) ||
            (dashboardStore.dashboard.L1CardValue === '' &&
              dashboardStore.dashboard.prodCount === 0) ? null : (
              <Grid.Column
                style={
                  !(
                    dashboardStore.dashboard.L1CardValue === 'Inventory' &&
                    dashboardStore.dashboard.L2CardValueInventory === 'Reports'
                  ) &&
                  user?.customerName === 'CG' &&
                  dashboardStore.dashboard.L2CardValueInventory !==
                    'Delivery' &&
                  dashboardStore.dashboard.L1CardValue !== 'Production'
                    ? { display: 'none' }
                    : {}
                }
              >
                <Bar
                  className={
                    commonStore.filterModeZero?.includes(chartRoleInfo?.[2]?.id)
                      ? 'component-isDisabled'
                      : ''
                  }
                  style={{ minHeight: '19rem' }}
                  data={Barchartdata}
                  options={{
                    plugins: {
                      legend: {
                        display: true,
                        position: 'bottom',
                      },
                    },
                  }}
                  // options={
                  //   {
                  //     scales: {
                  //       yAxes: [
                  //         {
                  //           ticks: {
                  //             beginAtZero: true,
                  //           },
                  //         },
                  //       ],
                  //     },
                  //   } as any
                  // }
                />
                <div
                  style={{
                    maxHeight: '150px',
                    overflowX: 'scroll',
                    columns: '2',
                  }}
                >
                  {barChartDataSet?.map((d) => {
                    return (
                      <Grid.Row key={d.val}>
                        <Grid.Column style={{ color: 'grey' }}>
                          <strong>{d.name}</strong>
                          <span>{d.val}</span>
                        </Grid.Column>
                      </Grid.Row>
                    );
                  })}
                </div>
              </Grid.Column>
            ))}
          {!commonStore.filterModeTwo?.includes(chartRoleInfo?.[3]?.id) && (
            <Grid.Column>
              <Doughnut
                width={60}
                height={60}
                className={
                  commonStore.filterModeZero?.includes(chartRoleInfo?.[3]?.id)
                    ? 'component-isDisabled'
                    : ''
                }
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                }}
                data={chartdata}
              />
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
export default observer(DashboardChart);
